import { createContext } from 'react';

export interface QffUser {
  memberId: string | null;
  title: string | null;
  firstName: string | null;
  lastName: string | null;
  pointsBalance: string;
  membershipTier: string | null;
}

interface Context {
  qffUser: QffUser | null;
  isLoading: boolean;
}

const QffUserContext = createContext<Context>({
  qffUser: null,
  isLoading: false,
});

export default QffUserContext;
